import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import { TranslateSportsPipe } from './translate-sports.pipe'; 

@NgModule({
  declarations:[TranslateSportsPipe],
  imports:[CommonModule],
  exports:[TranslateSportsPipe] 
})

export class TranslateSportsPipeModule{}